import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import SecondHandOrder from '@/store/entities/booking/secondHandOrder';

interface SecondHandOrderState extends ListState<SecondHandOrder>{
    editSecondHandOrder:SecondHandOrder
}
class SecondHandOrderMutations extends ListMutations<SecondHandOrder>{

}
class SecondHandOrderModule extends ListModule<SecondHandOrderState,any,SecondHandOrder>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<SecondHandOrder>(),
        loading:false,
        editSecondHandOrder:new SecondHandOrder()
    }
    actions={
        async getAll(context:ActionContext<SecondHandOrderState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/SecondHandOrder/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<SecondHandOrder>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<SecondHandOrderState,any>,payload:any){
            await Ajax.post('/api/services/app/SecondHandOrder/Create',payload.data);
        },
        async createWithImages(context:ActionContext<SecondHandOrderState,any>,payload:any){
            await Ajax.post('/api/services/app/SecondHandOrder/CreateWithImages',payload.data);
        },
        async update(context:ActionContext<SecondHandOrderState,any>,payload:any){
            await Ajax.put('/api/services/app/SecondHandOrder/Update',payload.data);
        },
        async updateWithImages(context:ActionContext<SecondHandOrderState,any>,payload:any){
            await Ajax.put('/api/services/app/SecondHandOrder/UpdateWithImages',payload.data);
        },
        async delete(context:ActionContext<SecondHandOrderState,any>,payload:any){
            context.state.loading=true;
            await Ajax.delete('/api/services/app/SecondHandOrder/Delete?Id='+payload.data.id);
            context.state.loading=false;
        },
        async get(context:ActionContext<SecondHandOrderState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/SecondHandOrder/Get?Id='+payload.id);
            return reponse.data.result as SecondHandOrder;
        }
    };
    mutations={
        setCurrentPage(state:SecondHandOrderState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:SecondHandOrderState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:SecondHandOrderState,secondHandOrder:SecondHandOrder){
            state.editSecondHandOrder=secondHandOrder;
        },
        changeLoading(state:SecondHandOrderState,pass:boolean){
            state.loading = pass;
        }
    }
}
const secondHandOrderModule=new SecondHandOrderModule();
export default secondHandOrderModule;